import { convertToImperial } from 'domain/Options/utils/convertMeasurement';
import planPageMessages from 'pages/MainPage/PlanPage/messages';


export function calcWallPanelErrorMessage(height, minHeight, maxHeight, useImperialUnits) {
  if (height === null || isNaN(height)) return null;
  if (height < minHeight || (useImperialUnits && height <= minHeight)) { // need to add hte =<, but for imperial only!
    let tempMinHeight;
    if (useImperialUnits) {
      tempMinHeight = Math.ceil(convertToImperial(minHeight));
    } else {
      tempMinHeight = minHeight;
    }
    const minHeightVal = tempMinHeight;
    return {
      ...(useImperialUnits ? planPageMessages.errorMinimumImperial : planPageMessages.errorMinimum),
      values: {
        value: minHeightVal,
      },
    };
  } else if (height > maxHeight) { // need to add hte >=, but for imperial only!
    let tempMaxHeight;
    if (useImperialUnits) {
      tempMaxHeight = convertToImperial(maxHeight);
    } else {
      tempMaxHeight = maxHeight;
    }
    const maxHeightVal = tempMaxHeight;
    return {
      ...(useImperialUnits ? planPageMessages.errorMaximumImperial : planPageMessages.errorMaximum),
      values: {
        value: maxHeightVal,
      },
    };
  } else {
    return null;
  }
}